import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import api from "../lib/api";
import { toast } from "sonner";
import Header from "../components/Header";

// AuthCallback (Google sign-in) intentionally removed — Safari ITP blocks the
// cross-site session_token cookie on arthursvault.com. Customers use
// email + password.

export function VerifyEmail() {
  const [params] = useSearchParams();
  const nav = useNavigate();

  useEffect(() => {
    const t = params.get("token");
    if (!t) return;
    api.post(`/auth/verify?token=${t}`)
      .then(() => { toast.success("Email verified"); nav("/my-vault"); })
      .catch(() => toast.error("Invalid token"));
  }, [params, nav]);

  return (
    <div>
      <Header />
      <div className="pt-32 text-center text-[var(--av-text-dim)]">Verifying your email…</div>
    </div>
  );
}

export function ResetPassword() {
  const [params] = useSearchParams();
  const [pw, setPw] = useState("");
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/auth/reset", { token: params.get("token"), password: pw });
      toast.success("Password reset");
      nav("/auth?mode=login");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Failed");
    }
  };

  return (
    <div>
      <Header />
      <div className="max-w-md mx-auto pt-32 px-4">
        <form onSubmit={submit} className="vault-card p-8 space-y-3">
          <h1 className="font-serif text-2xl gold-text">Reset Password</h1>
          <input
            required
            type="password"
            placeholder="New password"
            className="input-vault"
            value={pw}
            onChange={(e) => setPw(e.target.value)}
          />
          <button className="btn-gold w-full">Reset</button>
        </form>
      </div>
    </div>
  );
}

export function Legal() {
  const { page } = useParams();
  const titles = {
    terms: "Terms & Conditions",
    privacy: "Privacy Policy",
    rewards: "Apex Rewards Terms",
    refund: "Refund Policy",
    cookies: "Cookie Policy",
  };
  return (
    <div>
      <Header />
      <div className="max-w-3xl mx-auto pt-28 pb-16 px-4">
        <h1 className="font-serif text-3xl gold-text mb-4">{titles[page] || "Legal"}</h1>
        <p className="text-[var(--av-text-dim)] text-sm">
          Placeholder legal content. This page is editable by the owner and requires proper legal
          review before production launch.
        </p>
      </div>
    </div>
  );
}
